export default "__VITE_ASSET__B2l1uuel__"